export default "/images/huffpost.svg?1a395586cf83d8c8899c67767bbfdf02";